import { apiSlice } from "@/shared/api/api-slice"
import type { UploadDocumentRequest, UploadDocumentResponse } from "@/shared/types/api/business-mode.types"

// No invalidatesTags: a JSON import posts one item at a time and refreshes the list once when the run ends.
export const importBusinessDocumentApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    importBusinessDocument: builder.mutation<UploadDocumentResponse, UploadDocumentRequest>({
      query: request => ({
        url: "/api/v1/business/documents",
        method: "POST",
        body: request
      })
    })
  })
})

export const { useImportBusinessDocumentMutation } = importBusinessDocumentApi
